import React from 'react';
import { Shirt, Watch } from 'lucide-react';
import VistaBordado from './VistaBordado';
import CampoTexto from './CampoTexto';
import { bordadoElegido } from './tiendaUtils';

const ICONOS = { pecho: Shirt, puno: Watch };

const Lugares = ({ grupo, elegido, mangaCorta, onElegir }) => (
  <fieldset data-testid="bordado-lugares">
    <legend className="mb-2 text-sm font-medium text-white">¿Dónde las bordamos?</legend>
    <div className="grid grid-cols-2 gap-2">
      {grupo.ubicaciones.map(u => {
        const Icono = ICONOS[u.id] || Shirt;
        const bloqueado = mangaCorta && u.id === 'puno';
        const activo = elegido?.id === u.id;
        return (
          <button key={u.id} type="button" disabled={bloqueado} aria-pressed={activo} onClick={() => onElegir(u.id)}
            className={`flex items-center gap-2 rounded-xl border-2 px-3 py-3 text-left text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${activo ? 'border-[#C9A962] bg-[#C9A962]/10 text-[#C9A962]' : 'border-[#27272A] text-zinc-300 hover:border-zinc-600'}`}
            data-testid={`bordado-lugar-${u.id}`}>
            <Icono className="h-4 w-4 shrink-0" />
            <span>{u.titulo}{bloqueado && <span className="block text-[11px] text-zinc-500">No disponible con manga corta</span>}</span>
          </button>
        );
      })}
    </div>
  </fieldset>
);

const Colores = ({ grupo, elegido, onElegir }) => (
  <fieldset data-testid="bordado-colores">
    <legend className="mb-2 text-sm font-medium text-white">
      Color del hilo <span className="font-normal text-zinc-500" data-testid="bordado-color-elegido">· {elegido?.nombre}</span>
    </legend>
    <div className="flex flex-wrap gap-3">
      {grupo.colores_hilo.map((c, i) => {
        const activo = elegido?.nombre === c.nombre;
        return (
          <button key={c.nombre} type="button" title={c.nombre} aria-label={`Hilo ${c.nombre}`} aria-pressed={activo} onClick={() => onElegir(c.nombre)}
            className={`h-10 w-10 rounded-full border-2 transition-transform active:scale-95 ${activo ? 'scale-110 border-[#C9A962] ring-2 ring-[#C9A962]/50' : 'border-transparent hover:scale-105'}`}
            style={{ background: c.hex, boxShadow: 'inset 0 0 0 1px rgba(127,127,127,0.5)' }} data-testid={`bordado-color-${i}`} />
        );
      })}
    </div>
  </fieldset>
);

export default function PasoBordado({ grupo, valor, onCambiar, contexto }) {
  const { ubicacion, color } = bordadoElegido(grupo, valor, contexto.mangaCorta);
  const cambiar = (cambios) => onCambiar({ opcion_ids: [], texto: valor?.texto || '', ubicacion: ubicacion?.id || '', color_hilo: color?.nombre || '', ...cambios });
  return (
    <div className="grid gap-5 sm:grid-cols-2 sm:items-start" data-testid={`bordado-${grupo.id}`}>
      <div className="sm:sticky sm:top-4">
        <VistaBordado texto={valor?.texto || ''} placeholder={'JPM'.slice(0, grupo.max_caracteres)} ubicacion={ubicacion} color={color}
          tela={contexto.tela} telaNombre={contexto.telaNombre} />
      </div>
      <div className="space-y-5">
        <CampoTexto grupo={grupo} valor={valor} onCambiar={v => cambiar({ texto: v.texto })} />
        <Lugares grupo={grupo} elegido={ubicacion} mangaCorta={contexto.mangaCorta} onElegir={id => cambiar({ ubicacion: id })} />
        <Colores grupo={grupo} elegido={color} onElegir={nombre => cambiar({ color_hilo: nombre })} />
      </div>
    </div>
  );
}
